import { RootStore } from "../store/RootStore";
import LoginDialog from "../component/LoginDialog/LoginDialog";

export const needLogin = (func: Function) => {
    const returnFunc = (...args: any[]): any => {
        const commonStore = RootStore.common;
        if(!commonStore.getIsLogin()){
            LoginDialog.show(commonStore.toLoginPage);
            return;
        }
        return func.apply(args);
    };
    return returnFunc;
};